module.exports = __webpack_public_path__ + "static/media/ecomerit.50c6bdbe.png";